import {Injectable} from '@angular/core';
import {devolverDiaSem, MallaPorcentajeModel} from '../models/semana.model';
import * as moment from 'moment';
import {Indicadores} from '../components/tienda.component';

@Injectable()
export class IndicadoresServices {


  calcularIndicadoresTienda(ventas: any[], malla: MallaPorcentajeModel) {
    let indicadores: Indicadores = new Indicadores();


    for (let i = 0; i < 7; i++) {
      indicadores.meta += malla.dias[i].precio;
    }

    let totalVenta = 0;
    let articulos = 0;
    let ventasCredito = 0;

    for (let v of ventas) {
      if(v.tipodoc.includes("VN")){
        totalVenta -= v.cantidad;
        articulos -= v.articulos.length;
        ventasCredito++;
        indicadores.ticket--;
      }
      else {
        totalVenta += v.cantidad;
        articulos += v.articulos.length;
        indicadores.ticket++;
      }
    }

    indicadores.venta = totalVenta;
    // console.log(`total ventas creditos ${ventasCredito}`);
    if (ventas.length > 0)
      indicadores.ticketPromedio = totalVenta / (ventas.length- ventasCredito);
    if (ventas.length > 0)
      indicadores.articulosTicket = articulos / ventas.length;
      // indicadores.articulosTicket = 2.41;
    indicadores.completado = totalVenta / indicadores.meta * 100;

    indicadores.friedman = (indicadores.completado <= 89.99) ? 0 : (indicadores.completado <= 99.99) ? 1 : (indicadores.completado <= 109.99) ? 2 : 3;

    // ajustar para que sean los dias activos
    // console.log(`ventas ${ventas.length}`);
    indicadores.ventaxDia = indicadores.venta / 7;
    indicadores.ticketxDia = ventas.length / 7;



    return indicadores;
  }

  calcularIndicadoresDiarios(ventas: any[], malla: MallaPorcentajeModel) {

    // console.log(malla);

    let indicadores: IndicadoresDiarios[] = [];


    for (let i = 0; i < 7; i++) {
      let indi = new IndicadoresDiarios();
      indi.dia = devolverDiaSem(i);
      if (malla.dias[i].precio)
        indi.metaDia = malla.dias[i].precio;
      indicadores.push(indi);
    }



    for (let v of ventas) {
      let f = moment(v.fecha);

      let dia = f.day();
      // fix para dia, dado que para moment el dia 0 es domingo y para las ventas el dia 0 es lunes
      if (dia == 0)
        dia = 6;
      else
        dia -= 1;


      indicadores[dia].agregarVenta(v);
    }

    indicadores.map(i => i.calcularIndicadores());



    return indicadores;
  }
}


export class IndicadoresDiarios {

  ventas: any[] = [];
  dia: string = '';
  metaDia: number = 0;
  faltanteMeta: number = 0;
  ventaDia: number = 0;
  tickets: number = 0;
  articulos: number = 0;
ticket:number = 0;
  ticketPromedio: number = 0;
  articulosxTicket: number = 0;
  precioPromedio: number = 0;


  agregarVenta(v) {
    this.ventas.push(v);
  }

  calcularIndicadores() {
    let ventasCredito = 0;


    this.articulos = 0;
    this.ventaDia = 0;


    this.ventas.map(v => {
      if(v.tipodoc.includes("VN")){
        this.articulos -= v.articulos.length;
        this.ventaDia -= v.cantidad;
        this.ticket--;
        ventasCredito++;
      }
      else {
        this.articulos += v.articulos.length;
        this.ticket++;
        this.ventaDia += v.cantidad;
      }
    });

    this.tickets = this.ventas.length - ventasCredito;

    if (this.tickets > 0) {
      this.ticketPromedio = this.ventaDia / this.tickets;
      this.articulosxTicket = this.articulos / this.tickets;
    }

    if (this.articulos > 0)
      this.precioPromedio = this.ventaDia / this.articulos;

    this.faltanteMeta = this.metaDia - this.ventaDia;
    if (this.faltanteMeta < 0)
      this.faltanteMeta = 0;

  }
}
